import { useState } from "react";
import { SendTransactionState, SendTransactionStateRecipient } from "../pages/chat/wallet/SendTransaction";
import { walletRepository } from "../repositories/WalletRepository";

export function useWalletSend() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    
    const scanRecipient = async (recipient: SendTransactionStateRecipient) : Promise<SendTransactionState | null> => {
        let ret = null;
        setLoading(true);
        setError('');
        
        try {
            if (recipient.bulkPayment) {
                // Handle bulk payment
                const data = await walletRepository.scanBulkPayment(
                    recipient.bulkPayment.type, 
                    recipient.bulkPayment.id
                );
                
                ret = {
                    recipient: {
                        pleb: null,
                        lnurl: '',
                        bulkPayment: data,
                    },
                }
            } else {
                // Handle regular payment
                const lnurlToScan = recipient.lnurl === '' 
                    ? recipient?.pleb?.getLnUrlToPayTo() ?? '' 
                    : recipient?.lnurl ?? '';
                    
                const data = await walletRepository.scan(lnurlToScan);
                
                // Update recipient with scan data
                if (recipient.lnurl !== '') {
                    recipient.lnurl = data.lnurl;
                }
                
                if (recipient.invoice !== '') {
                    recipient.invoice = data.invoice;
                }
                
                // If the pleb has an encoded lnurl in the zapAddress, we need to update it
                if (recipient.pleb && recipient.pleb.shouldShowNameAndPicture() === false) {
                    recipient.pleb.zapAddress = data.lnurl;
                }
                
                ret = {
                    scanData: data,
                    recipient: recipient,
                }
            }
        } catch (err: any) {
            // Handle errors
            if (err.response?.data?.error) {
                setError(err.response.data.error);
            } else {
                console.error('Error in scanRecipient:', err);
                setError('Unknown error');
            }
        } finally {
            setLoading(false);
        }

        return ret;
    };

    return {
        loading: loading,
        setLoading: setLoading,
        error: error,
        setError: setError,
        scanRecipient: scanRecipient
    }
}